import { ReactNode } from "react";

interface CardPayload {
    desc: ReactNode;
}
const Card = (cardPayload: CardPayload) => {
    return (
        <div className="space-y-4 w-full" >
            <div
                className="bg-[#FFFFFF26] rounded-3xl p-4"
                style={{
                    backdropFilter: 'blur(27.6px)',
                }}
            >
                {cardPayload.desc}
            </div>
        </div>
    )
}
export default Card;